<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { getClientContract, getContract } from "@/api/user/CustomerContract";

import cTable from "@/base/common/index";
import { getUser } from "@/api/user/internal";
import { getCompanies } from "@/api/user/client";
export default {
  name: "customer_contract",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getClientContract,
        beforeHandleList({ data }) {
          data.rows.map((item, index) => {
            item.length =
              index + 1 + (this.pageConfig.page - 1) * this.pageConfig.size;
            return item;
          });
        },
        getContract,
        getCompanies
      },
      config: {
        height: 630
      },
      modals: {},
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            disabledDate() {
              return true;
            },
            bind: {
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            disabledDate() {
              return true;
            },
            bind: {
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "type",
            placeholder() {
              return this.$t("select") + this.$t("contract_type");
            },
            component: "Select",
            options: []
          },
          {
            key: "title",
            placeholder() {
              return this.$t("select") + this.$t("contract_title");
            },
            component: "Select",
            options: []
          },
          {
            key: "salesman",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id"
            }
          },
          {
            key: "isExpire",
            placeholder() {
              return (
                this.$t("select") + this.$t("whether") + this.$t("Expired")
              );
            },
            component: "Select",
            options: [
              {
                label: this.$t("Expired"),
                value: "YES"
              },
              {
                label: this.$t("Not") + this.$t("Expired"),
                value: "NO"
              }
            ]
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.openLoading();
              this.handleRequestMethods(
                "list",
                {
                  export: 1
                },
                false,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload.src);
                this.closeLoading();
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("contract_account"),
          align: "left",
          key: "account",
          minWidth: 100
        },
        {
          name: () => this.$t("contract_type"),
          key: "type",
          align: "left",
          minWidth: 130
        },
        {
          name: () => this.$t("contract_title"),
          key: "title",
          align: "left",
          minWidth: 130
        },
        {
          name: () => this.$t("spare_contract_header"),
          key: "spare_contract_header",
          align: "left",
          minWidth: 130
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership",
          align: "left",
          minWidth: 130
        },
        {
          name: () => this.$t("company_t") + this.$t("invoiceName"),
          align: "left",
          key: "shipper_company",
          minWidth: 100
        },
        {
          name: () => this.$t("shipper_company_cn"),
          align: "left",
          key: "shipper_company_cn",
          minWidth: 100
        },
        {
          name: () => this.$t("contract_start_time"),
          key: "start_time",
          align: "left",
          minWidth: 110
        },
        {
          name: () => this.$t("contract_end_time"),
          key: "end_time",
          align: "left",
          minWidth: 110
        },
        {
          name: () => this.$t("isPaper"),
          key: "has_paper",
          minWidth: 120,
          methods: {
            render({ row }) {
              return row.has_paper ? this.$t("contain") : this.$t("Useless");
            }
          }
        },
        {
          name: () => this.$t("AccountOpeningDate"),
          key: "create_time",
          minWidth: 100
        },
        {
          name: () => this.$t("salesman"),
          align: "left",
          key: "salesman",
          minWidth: 100
        },
        {
          name: () => this.$t("whether") + this.$t("Expired"),
          key: "is_expired",
          minWidth: 100,
          methods: {
            render({ row }) {
              return row.is_expired
                ? this.$t("Expired")
                : this.$t("Not") + this.$t("Expired");
            }
          }
        },
        {
          name: () => this.$t("Expired") + this.$t("countdown"),

          key: "bcmul",
          minWidth: 110
        },
        {
          name: () => this.$t("Remarks"),
          align: "left",
          key: "remark",
          minWidth: 100
        }
      ]
    };
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "country_id")
        item.options = (await getCountry()).data.payload.rows;
      if (item.key === "ownership")
        item.options = (await getCompanies()).data.payload;
      if (item.key === "title")
        item.options = (await getContract({ type: 1 })).data.payload;
      if (item.key === "type")
        item.options = (await getContract({ type: 2 })).data.payload;
      if (item.key === "salesman")
        item.options = (
          await getUser({ standard: "Salesman" })
        ).data.payload.rows;
    });
  }
};
</script>
